import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading } from "../../Slice/loading/loadingSlice";
import authApi from "../../authApi";
import { setFlCounts, setFlInvoiceCounts, setFreelanceDashboardData, setFreelanceUserListing, setFreelanceUserListingFinal, setgetOneJobsummury, setJobsFromTmsSummeryViewSearch, setjobSummeryDetailsGet } from "../../Slice/FreelanceScreenModule/FreelanceSlice";
import { showSnackbar } from "../../Slice/snackbar/snackbarSlice";

export const freelanceJobTabCounts = createAsyncThunk(
  "freelanceJobTabCounts/list",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.get(`/freelanceJobTabCounts/${request}`);
      if (response?.status === 200) {
        dispatch(setFlCounts(response?.data));
        return response?.data;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getAllInvoiceByUserIdCount = createAsyncThunk(
  "getAllInvoiceByUserIdCount/list",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.get(`/getAllInvoiceByUserIdCount/save/${request}`);
      if (response?.status === 200) {
        dispatch(setFlInvoiceCounts(response?.data));
        return response?.data;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const freelanceDashboard = createAsyncThunk(
  "freelanceJob/list",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.get(`/freelanceJob/${request?.id}?page=${request?.page + 1}&perPage=${request?.perPage}&currentTab=${request?.tabName}&column=${request?.sortBy}&direction=${request?.sortOrder}&search=${request?.search}`);
      if (response?.status === 200) {
        dispatch(setFreelanceDashboardData(response?.data));
        return response?.data;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getAllInvoiceFreelanceUser = createAsyncThunk(
  "freelanceJob/list",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.get(`/getAllInvoiceByUserId/save/${request?.id}?page=${request?.page}&perPage=${request?.perPage}&currentTab=${request?.tabName}&column=${request?.sortBy}&direction=${request?.sortOrder}&search=${request?.search}`);
      if (response?.status === 200) {
        dispatch(setFreelanceUserListing(response?.data));
        return response?.data;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const freelanceJobForInvoice = createAsyncThunk(
  "freelanceJobForInvoice/list",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.get(`/freelanceJobForInvoice/${request}`);
      if (response?.status === 200) {
        dispatch(setFreelanceUserListingFinal(response?.data));
        return response?.data;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getJobSummeryFreelancerByFilter = createAsyncThunk(
  "getJobSummeryFreelancerByFilter/list",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.post(`/getJobSummeryFreelancerByFilter`, request);
      if (response?.status === 200) {
        dispatch(setJobsFromTmsSummeryViewSearch(response?.data));
        return response?.data;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const jobSummeryDetailsGet = createAsyncThunk(
  "jobSummeryDetailsGet/list",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(`/jobSummeryDetailsGetFreelancer/${request}`);
      if (response?.data?.status === 200) {
        dispatch(setjobSummeryDetailsGet(response?.data));
        return response?.data;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getOneJobsummury = createAsyncThunk(
  "getOneJobsummury/list",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.get(`/getOneJobsummury/${request}`);
      if (response?.status === 200) {
        dispatch(setgetOneJobsummury(response?.data));
        return response?.data;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const jobSummeryWorkinstructUpdate = createAsyncThunk(
  "jobSummeryWorkinstructUpdate/list",
  async ({id, payload}, { dispatch }) => {
    //dispatch(setLoading(true));
    try {
      const response = await authApi.put(`/jobSummeryWorkinstructUpdate/${id}`, payload);
      if (response?.status === 200) {
        //return response?.data;
        return { success: true };
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const rejectJobStatus = createAsyncThunk(
  "rejectJobStatus",
  async ({id, payload}, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.put(`/rejectJobStatus/${id}`, payload);
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        )
        return response?.data;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const acceptJobStatus = createAsyncThunk(
  "acceptJobStatus",
  async ({id, payload}, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.put(`/acceptJobStatus/${id}`, payload);
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        )
        return response?.data;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const sendjobResourceMsg = createAsyncThunk(
  "sendjobResourceMsg",
  async ( request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.post(`/sendjobResourceMsg`, request);
      if (response?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        )
        return response?.data;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);